var _path, _rect, _rect2, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#8977A0",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#8977A0",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.5H17.6875C18.4111 15.5 19 14.9111 19 14.1875V6.3125C19 5.58887 18.4111 5 17.6875 5H6.3125C5.58887 5 5 5.58887 5 6.3125V19L9.66638 15.5H17.25ZM9.08362 13.75L6.75 15.5V6.75H17.25V13.75H9.08362Z",
    fill: "#8977A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5H20V-1.5H4V1.5ZM22.5 4V20H25.5V4H22.5ZM20 22.5H4V25.5H20V22.5ZM1.5 20V4H-1.5V20H1.5ZM4 22.5C2.61929 22.5 1.5 21.3807 1.5 20H-1.5C-1.5 23.0376 0.962435 25.5 4 25.5V22.5ZM22.5 20C22.5 21.3807 21.3807 22.5 20 22.5V25.5C23.0376 25.5 25.5 23.0376 25.5 20H22.5ZM20 1.5C21.3807 1.5 22.5 2.61929 22.5 4H25.5C25.5 0.962434 23.0376 -1.5 20 -1.5V1.5ZM4 -1.5C0.962434 -1.5 -1.5 0.962435 -1.5 4H1.5C1.5 2.61929 2.61929 1.5 4 1.5V-1.5Z",
    fill: "#8977A0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.3a18146931aa001310f64582cc98f831.svg";
export { ForwardRef as ReactComponent };